// Application-managed enum for the `name` column on `SocietySettingAdmin`
// (and the `SocietySettingPublic` view).
//
// Previously this was a Postgres enum (`public.society_setting_name`) generated
// into `prisma-generated`. The DB column is now a plain TEXT column so this enum
// is the single source of truth for valid society setting names.
//
// To add a new setting, add a member here — no database migration is required.
// See docs/project-conventions/ADDING_A_SOCIETY_SETTING.MD.
export enum society_setting_name {
  ably_enabled = "ably_enabled",
  accounting_ms_teams_notification_webhook_url = "accounting_ms_teams_notification_webhook_url",
  activity_log_template_attendance = "activity_log_template_attendance",
  activity_log_template_education = "activity_log_template_education",
  activity_log_template_group = "activity_log_template_group",
  activity_log_template_mentorship = "activity_log_template_mentorship",
  activity_log_template_other = "activity_log_template_other",
  activity_log_template_profile = "activity_log_template_profile",
  activity_log_template_reviews = "activity_log_template_reviews",
  activity_log_template_submissions = "activity_log_template_submissions",
  add_existing_user_to_institution_workflow_id = "add_existing_user_to_institution_workflow_id",
  add_new_user_to_institution_workflow_id = "add_new_user_to_institution_workflow_id",
  authorize_dot_net_api_url = "authorize_dot_net_api_url",
  authorize_dot_net_api_url_accept_suite = "authorize_dot_net_api_url_accept_suite",
  authorize_merchant_name = "authorize_merchant_name",
  authorize_public_client = "authorize_public_client",
  authorize_transaction_key = "authorize_transaction_key",
  automatic_invoice_ignore_expiration_older_than_days = "automatic_invoice_ignore_expiration_older_than_days",
  automatic_invoice_ignore_expiration_skip_missed = "automatic_invoice_ignore_expiration_skip_missed",
  aws_config = "aws_config",
  aws_secret_keys = "aws_secret_keys",
  conference_schedule_pdf = "conference_schedule_pdf",
  confirm_profile_older_than_days = "confirm_profile_older_than_days",
  create_temp_profile_workflow_complex_id = "create_temp_profile_workflow_complex_id",
  default_accepted_decision_email_template = "default_accepted_decision_email_template",
  default_automatic_invoice_email_template = "default_automatic_invoice_email_template",
  default_email_sender = "default_email_sender",
  default_invite_to_institution_email_template = "default_invite_to_institution_email_template",
  default_invoice_email_template = "default_invoice_email_template",
  default_primary_submitters_email_template_id = "default_primary_submitters_email_template_id",
  default_product_class = "default_product_class",
  default_rejected_decision_email_template = "default_rejected_decision_email_template",
  default_renewal_reminder_email_template = "default_renewal_reminder_email_template",
  default_temp_password = "default_temp_password",
  default_update_password_email_template = "default_update_password_email_template",
  default_profile_address_contact_information = "default_profile_address_contact_information",
  donation_checkout_product_group = "donation_checkout_product_group",
  finance_recognize_day_of_month = "finance_recognize_day_of_month",
  firebase_admin_secrets = "firebase_admin_secrets",
  fiscal_year_start_day = "fiscal_year_start_day",
  fiscal_year_start_month = "fiscal_year_start_month",
  google_maps_api_key = "google_maps_api_key",
  google_maps_geocode_enabled = "google_maps_geocode_enabled",
  hub_heading_template = "hub_heading_template",
  include_default_sender_on_emails = "include_default_sender_on_emails",
  invite_to_institution_form_id = "invite_to_institution_form_id",
  invoice_expiration_days = "invoice_expiration_days",
  invoice_pdf_settings = "invoice_pdf_settings",
  invoice_pdf_template = "invoice_pdf_template",
  membership_enabled = "membership_enabled",
  membership_include_lapsed = "membership_include_lapsed",
  outdated_profile_navigate_to_edit_text = "outdated_profile_navigate_to_edit_text",
  outdated_profile_navigate_to_invoice_text = "outdated_profile_navigate_to_invoice_text",
  pathlms_access_token = "pathlms_access_token",
  pathlms_api_client_id = "pathlms_api_client_id",
  pathlms_api_client_secret = "pathlms_api_client_secret",
  pathlms_api_url = "pathlms_api_url",
  pdf_invoice = "pdf_invoice",
  pillar_group_disclosure_word_export = "pillar_group_disclosure_word_export",
  pillar_profile_overview_institution = "pillar_profile_overview_institution",
  pillar_profile_overview_society_user = "pillar_profile_overview_society_user",
  quickbooks_online_config = "quickbooks_online_config",
  range_product_cutoff_day = "range_product_cutoff_day",
  range_product_cutoff_month = "range_product_cutoff_month",
  refund_product = "refund_product",
  remove_user_from_institution_workflow_id = "remove_user_from_institution_workflow_id",
  send_renewal_emails = "send_renewal_emails",
  society_banner_logo_url = "society_banner_logo_url",
  society_login_logo_url = "society_login_logo_url",
  task_management_task_type = "task_management_task_type",
  update_password_form_id = "update_password_form_id",
  user_hub_overview_institution = "user_hub_overview_institution",
  user_hub_overview_society_user = "user_hub_overview_society_user",
  userhub_url = "userhub_url",
  zoom_api_account_id = "zoom_api_account_id",
  zoom_api_client_id = "zoom_api_client_id",
  zoom_api_client_secret = "zoom_api_client_secret",
  hub_check_message = "hub_check_message",
  hub_payment_types = "hub_payment_types",
  membership_card_enabled = "membership_card_enabled",
  membership_card_template = "membership_card_template",
  membership_grace_period = "membership_grace_period",
  invoice_receipt_html_template = "invoice_receipt_html_template",
  default_group_workflow = "default_group_workflow",
  /**
   * Each integration keeps its API key in a secret `<integration>_api_key` STRING setting and
   * everything else in a non-secret `<integration>_config` OBJECT setting
   * (`admin/src/server/bll/settings/integration/`).
   */
  billhighway_api_key = "billhighway_api_key",
  billhighway_config = "billhighway_config",
  higherlogic_api_key = "higherlogic_api_key",
  higherlogic_config = "higherlogic_config",
  tiered_shipping_charge = "tiered_shipping_charge",
  tax_jar = "tax_jar",
  default_profile_custom_report_id = "default_profile_custom_report_id",
  profile_workflow_id = "profile_workflow_id",
  society_app_deep_link_url = "society_app_deep_link_url",
  prolydian_intergration = "prolydian_intergration",
  member_planet_api_key = "member_planet_api_key",
  member_planet_config = "member_planet_config",
  profile_update_config = "profile_update_config",
  elevate_report_api_config = "elevate_report_api_config",
  websocket_enabled = "websocket_enabled",
  push_notifications_enabled = "push_notifications_enabled",
  websocket_endpoint_base_url = "websocket_endpoint_base_url",
  default_app_route = "default_app_route",
  hub_mobile_app_heading_template = "hub_mobile_app_heading_template",
  hub_default_platform_config = "hub_default_platform_config",
}
